import {Box3, Vector3} from "three";
import {toFixedFloat} from "../../../utils/utils";
import {RoofOrientation} from "../../../constants/roofConstants";
import {t} from "../../../../i18n";

/*
* Bestimmt aus den zuvor berechneten Spannpositionen die jeweiligen Spannweiten zwischen den Elementen.
* */
export class SpanCalculator {
    constructor(roofConfiguration, raehme, spanPositions) {
        this.roof = roofConfiguration.roof;
        this.orientation = roofConfiguration.orientation;
        let size = new Box3().setFromObject(this.roof).getSize(new Vector3());
        this.width = this.orientation === RoofOrientation.XAxis ? size.x : size.z;
        this.depth = this.orientation === RoofOrientation.XAxis ? size.z : size.x;
        this.spanPositions = spanPositions;
        this.spans = [];
    }

    calculateSpansFromPositions() {
        //Alle intersections eines Wandelements
        if (this.spanPositions.length >= 2) {
            for (let i = 1; i < this.spanPositions.length; i++) {
                //Berechnung der Spannweite zwischen zwei tragenden Elementen
                //Distanz zwischen den Elementen
                let span = toFixedFloat(this.getDistanceBetweenIntersects(this.spanPositions[i - 1], this.spanPositions[i], this.orientation));
                if (span === null) {
                    throw new Error(t("span_between_positions"));
                }

                this.spans.push(span);
            }
        }

        return this.spans;
    }

    getMaxSpan() {
        if (this.spans.length > 0) {
            return Math.max(...this.spans);
        } else {
            return null;
        }
    }

    getDistanceBetweenIntersects(firstIntersect, secondIntersects, orientation) {
        //Parameter: Box3, Box3, RoofOrientation
        //Berechnung der Distanz abhängig von Orientierung
        if (orientation === RoofOrientation.XAxis) {
            return Math.abs(firstIntersect.start.x - secondIntersects.start.x);
        } else {
            return Math.abs(firstIntersect.start.z - secondIntersects.start.z);
        }
    }
}
